<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app { font-family: 'Avenir', Helvetica, Arial, sans-serif; color: #1f2d3d; background: #f7f8fa; }
.container { max-width: 1080px; margin: 0 auto; padding: 12px; }
.card { background: #fff; border: 1px solid #e6ebf1; border-radius: 8px; box-shadow: 0 1px 2px rgba(0,0,0,.03); }
.card + .card { margin-top: 12px; }
.card__header { padding: 12px 16px; border-bottom: 1px solid #f0f2f5; font-weight: 600; }
.card__body { padding: 12px 16px; }
.toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.btn { padding: 6px 12px; border: 1px solid #d4dbe6; border-radius: 6px; background: #fff; cursor: pointer; transition: all .15s ease; }
.btn:hover { background: #f6f8fb; }
.btn.primary { background: #409eff; color: #fff; border-color: #3a8ee6; }
.btn.danger { background: #f56c6c; color: #fff; border-color: #e45656; }
.btn.ghost { background: transparent; }
.badge { display: inline-block; padding: 2px 6px; border-radius: 999px; font-size: 12px; line-height: 16px; }
.badge.success { background: #e8f7ee; color: #1f8a53; }
.badge.info { background: #e8f3ff; color: #2468c9; }
.badge.warn { background: #fff7e6; color: #a15f00; }
.section { margin: 12px 0; }
.sticky-table { overflow: auto; }
.sticky-table table { border-collapse: collapse; width: 100%; table-layout: fixed; }
.sticky-table th, .sticky-table td { border: 1px solid #eef2f7; padding: 8px; }
.sticky-table thead th { position: sticky; top: 0; background: #fbfcfe; z-index: 1; }
.muted { color: #6b778c; }
.mono { font-family: monospace; word-break: break-all; white-space: pre-wrap; }
</style>



// WEBPACK FOOTER //
// src/App.vue